/**
 * Repeatable Summary sections always render at least one editor-aligned unit block
 * so Name/Type lead each block even before the user saves configurations.
 */

export function withRepeatableSummaryPlaceholderUnit<T>(
  units: readonly T[],
): T[] {
  return units.length > 0 ? [...units] : [{} as T];
}
